import { render, staticRenderFns } from "./nxArea.vue?vue&type=template&id=6c4c3be3&scoped=true&"
import script from "./nxArea.vue?vue&type=script&lang=js&"
export * from "./nxArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c3be3",
  null
  
)

export default component.exports